module.exports = __webpack_public_path__ + "static/media/nectarine.64df0ffb.svg";